import { render, staticRenderFns } from "./code.vue?vue&type=template&id=5257c6c0&scoped=true"
import script from "./code.vue?vue&type=script&lang=ts"
export * from "./code.vue?vue&type=script&lang=ts"
import style0 from "./code.vue?vue&type=style&index=0&id=5257c6c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257c6c0",
  null
  
)

export default component.exports